import {
  StyledInputNumber,
  StyledInputLabel,
  IncrementNumberFieldWrapper,
  IncrementNumberFieldButton,
} from "./style";
import { NumberFieldProps } from "./interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as MinusIcon } from "../../assets/icons/MinusCircleSmall.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/PlusCircleSmall.svg";

export const IncrementNumberField = (props: NumberFieldProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState((props.value as number) || 1);

  const increment = () =>
    setValue((prev) => {
      if (props.max && prev >= props.max) return prev;
      return prev + 1;
    });
  const decrement = () => setValue((prev) => Math.max(1, prev - 1));

  useEffect(() => {
    if (value !== props.value) {
      setValue(props.value as number);
    }
  }, [props.value]);

  useEffect(() => {
    if (value !== props.value) {
      props.onChange && props.onChange(value);
    }
  }, [value]);

  return (
    <IncrementNumberFieldWrapper>
      {props.label && <StyledInputLabel>{props.label}</StyledInputLabel>}
      {props.isEditable && (
        <IncrementNumberFieldButton icon={<PlusIcon />} onClick={increment} />
      )}
      <StyledInputNumber max={props.max || 100} value={value} />
      {props.isEditable && (
        <IncrementNumberFieldButton icon={<MinusIcon />} onClick={decrement} />
      )}
    </IncrementNumberFieldWrapper>
  );
};
